// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ProductPromotionMaterialTypeEnum {
  MassNotificationDevices = 77,
  SiemensMaterial = 83,
  VESDAMaterial = 86,
  SiPassMaterial = 80,
}
